export default "__VITE_ASSET__CdeEVNby__"